<template>
    <v-container class="outer-div pa-0" fluid>
        <v-overlay :value="isLoading"></v-overlay>
        <!-- =============================================== -->
        <v-row v-show="hostname != 'hiroshima.ikelog.cloud'">
            <v-col>
                <v-layout justify-center>
                    <v-img :src="LogoImg" max-width="300"></v-img>
                </v-layout>
            </v-col>
        </v-row>
        <!-- =============================================== -->
        <v-row v-show="hostname == 'hiroshima.ikelog.cloud'" align="center" justify="center">
            <v-col class="text-center" cols="12">
                <v-layout justify-center align-center>
                    <h2 class="white--text d-inline py-16">ため池遠隔監視システム</h2>
                </v-layout>
            </v-col>
        </v-row>
        <!-- =============================================== -->
        <v-row>
            <v-col>
                <div class="px-5">
                    <v-text-field solo v-model="username" placeholder="アカウント"></v-text-field>
                    <v-text-field solo v-model="password" placeholder="パスワード" type="password"></v-text-field>
                    <v-btn block color="primary darken-4" @click="jwtauth()" class="pa-7"><h3>ログイン</h3></v-btn>
                    <h5 class="white--text text-right mt-5">Ver {{ ver }}</h5>
                </div>
            </v-col>
        </v-row>
        <!-- =============================================== -->
    </v-container>
</template>

<style>
.outer-div {
    display: table;
    width: 100vw;
    height: 100vh;
    padding: 0px;
    background: radial-gradient(aquamarine, darkslategray);
}
</style>

<script>
import Version from "@/version.json";
const url = require("url");
export default {
    name: "Login",
    //#######################################################
    data() {
        return {
            ver: Version.version,
            dbVersion: [],
            LogoImg: require("@/assets/logo.png"),
            parallaxImg: require("@/assets/parallax.png"),
            username: "",
            password: "",
            dbUsers: [],
            hostname: "",
            isLoading: false,
        };
    },
    //#######################################################
    created: function () {
        if (this.$localStorage.get("username")) this.username = this.$localStorage.get("username");
        if (this.$localStorage.get("password")) this.password = this.$localStorage.get("password");
        window.scrollTo(0, 0);

        const parseUrl = url.parse(document.URL);
        this.hostname = parseUrl.hostname;
    },
    //#######################################################
    mounted: function () {
        this.getVersion();
    },
    //#######################################################
    methods: {
        //===============================================
        // alter table versions add column r4_version varchar(80) not null default '' ;
        //===============================================
        getVersion() {
            this.axios({
                method: "GET",
                url: "/web/versions",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbVersion = response.data.json[0];
                if (this.dbVersion.version) {
                    if (this.dbVersion.version > this.ver) {
                        if (confirm("新しいバージョンがあります。\n更新しますか？")) {
                            this.reloadApp();
                        }
                    }
                }
            });
        },
        //===============================================
        // バージョンアップ（サービスワーカーを解除し、リロードで再登録する）
        async reloadApp() {
            window.navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (let registration of registrations) registration.unregister();
            });
            await new Promise((r) => setTimeout(r, 1000));
            window.location.reload();
            await new Promise((r) => setTimeout(r, 1000));
            alert("更新しました。\n再起動して下さい。");
        },
        //===============================================
        jwtauth() {
            this.username = this.username.trim();
            this.password = this.password.trim();
            if (!this.username) return false;
            if (!this.password) return false;
            //--------------------------
            this.isLoading = true;
            this.axios({
                method: "POST",
                url: "/web/api/authenticate",
                data: {
                    username: this.username,
                    password: this.password,
                    ver: Version.version,
                },
                timeout: 30000, // 30000ms
            })
                .then((response) => {
                    let jwt = response.data.token;
                    this.dbUsers = response.data.json;
                    if (jwt) {
                        this.$localStorage.set("jwt", jwt);
                        this.$localStorage.set("username", this.username);
                        this.$localStorage.set("password", this.password);
                        this.$router.push({ path: "/" });
                    } else {
                        alert("登録がありません。");
                        this.isLoading = false;
                    }
                })
                .catch((error) => {
                    alert("認証エラー");
                    self.console.log(error);
                    this.isLoading = false;
                });
            this.isLoading = false;
        },
        //===============================================
    },
    //#######################################################
};
</script>
